import { view } from '@yola/ws-sdk';
import { EDITOR_BREAKPOINTS } from '../constants/breakpoints';

const removeResponsiveClassesForAllBreakpoints = (element, className) => {
  const currentClass = element.getAttribute('class');
  if (!currentClass) return;

  const cleanedClass = EDITOR_BREAKPOINTS.reduce(
    (classValue, breakpoint) =>
      view.helpers.removeResponsiveClasses({
        currentClass: classValue,
        className,
        breakpoint,
      }),
    currentClass
  );

  if (cleanedClass === currentClass) return;

  if (cleanedClass) {
    element.setAttribute('class', cleanedClass);
  } else {
    element.removeAttribute('class');
  }
};

export default removeResponsiveClassesForAllBreakpoints;
